import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import CreateButton from '../CreateButton';
import Errored from '../Errored';
import Help from '../Help';
import IRIgeneration from '../IRIgeneration';
import LabelledSwitch from '../LabelledSwitch';
import OrderedUnordered from '../OrderedUnordered';
import PrimaryButton from '../PrimaryButton';
import SlashHash from '../SlashHash';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '../utils/constants';
import BaseIRI from './BaseIRI';

class ComponentDialog extends React.Component {

    state = {
        open: false,
        title: "",
        description: "",
        iriType: "Slash",
        orderType: "Ordered",
        defaultToXL: false,
        iriFormat: "UUID",
        isValidIRI: false,
        componentIRI: ""
    };

    handleClickOpen = () => { this.setState({ open: true }); };

    addComponent = () => {
        this.setState({ open: false });
        const isSlashIRI = this.props.slashHash ? this.state.iriType === 'Slash' : null;
        const isUuidIRI = this.props.slashHash ? this.state.iriFormat === 'UUID' : null;
        const isOrdered = this.props.order ? this.state.orderType === 'Ordered' : false;
        this.props.onAddComponent(this.state.title.trim(), this.state.componentIRI, isSlashIRI,
            this.state.description.trim(), this.props.lang, isOrdered, isUuidIRI, this.state.defaultToXL);
        this.setState({
            title: "",
            description: "",
            componentIRI: "",
            isValidIRI: false,
            defaultToXL: false,
            orderType: "Ordered",
            iriFormat: "UUID",
            iriType: "Slash"
        });
    };

    exitAddComponent = () => {
        this.setState({
            title: "",
            description: "",
            componentIRI: "",
            open: false,
            isValidIRI: false,
            defaultToXL: false,
            orderType: "Ordered",
            iriFormat: "UUID",
            iriType: "Slash"
        });
    };

    handleChange = event => {
        const t = event.target;
        this.setState({ [t.name]: t.value.trimLeft() });
    };

    handleXLChange = (defaultToXL) => this.setState({ defaultToXL });

    handleIRIChange = (componentIRI, isValidIRI) => this.setState({ componentIRI, isValidIRI, checking: false });

    onUpdateIRI = () => this.setState({ isValidIRI: false, checking: true });

    render() {

        const { classes, lang, label, slashHash, order, dataTest, useXL, project, existingComponents } = this.props;
        const { title, description, iriType, iriFormat, orderType, defaultToXL, isErrored, checking, isValidIRI } = this.state;

        if (isErrored) return <Errored data={isErrored} />;

        return (
            <React.Fragment>
                <CreateButton dataTest={"create-" + dataTest} onClick={this.handleClickOpen} label={label} />
                <Dialog
                    data-test="create-component"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={this.state.open} onClose={this.exitAddComponent} aria-labelledby="component-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="component-dialog-title">{label}</DialogTitle>
                    <DialogContent>
                        <Help textRef="IRI" />
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="title"
                                name="title"
                                title="Title"
                                autoFocus={true}
                                required={true}
                                text={title}
                                placeholder="Enter title"
                                maxLength={MAX_TITLE_LENGTH}
                                lang={lang}
                                onChange={this.handleChange} />
                        </form>
                        <BaseIRI
                            existingComponents={existingComponents}
                            project={project}
                            onUpdateIRI={this.onUpdateIRI}
                            onValidatedIRI={this.handleIRIChange} />
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="description"
                                name="description"
                                title="Description"
                                text={description}
                                placeholder="Enter description"
                                margin={true}
                                maxLength={MAX_DESCRIPTION_LENGTH}
                                lang={lang}
                                onChange={this.handleChange} />
                            {slashHash &&
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <div style={{ flex: 1, marginRight: '8px' }}>
                                        <SlashHash onChange={this.handleChange} iriType={iriType} />
                                    </div>
                                    <div style={{ flex: 1, marginLeft: '8px' }}>
                                        <IRIgeneration onChange={this.handleChange} iriFormat={iriFormat} />
                                    </div>
                                </div>
                            }
                            {useXL &&
                                <LabelledSwitch
                                    dataTest="defaultToXL"
                                    disabled={false}
                                    checked={defaultToXL}
                                    handleChange={this.handleXLChange}
                                    label="Use XL for Labels" />
                            }
                            {order && <OrderedUnordered onChange={this.handleChange} orderType={orderType} />}
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddComponent} />
                        <PrimaryButton
                            disabled={title.length === 0 || !isValidIRI || checking} onClick={this.addComponent}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

ComponentDialog.defaultProps = {
    order: false,
    useXL: false,
    existingComponents: []
};

ComponentDialog.propTypes = {
    classes: PropTypes.object,
    dataTest: PropTypes.string,
    existingComponents: PropTypes.array,
    label: PropTypes.string.isRequired,
    lang: PropTypes.string,
    project: PropTypes.string.isRequired,
    slashHash: PropTypes.bool.isRequired,
    useXL: PropTypes.bool,
    order: PropTypes.bool,
    onAddComponent: PropTypes.func.isRequired
};

export default withStyles(styles)(ComponentDialog);